import {Level} from 'shells/icon-status/icon-status';

export function getSharedInboxRowStatus(
    hasEmailAddress: boolean,
    isForwardingVerified: boolean,
    isReplyingVerified: boolean
): {level: Level; text: string} {
    if (!hasEmailAddress) {
        return {level: Level.PENDING, text: 'Not set up'};
    }

    if (isForwardingVerified && isReplyingVerified) {
        return {level: Level.VERIFIED, text: 'Verified'};
    }

    if (!isForwardingVerified && !isReplyingVerified) {
        return {level: Level.PENDING, text: 'Not verified'};
    }

    if (!isForwardingVerified) {
        return {level: Level.PENDING, text: 'Forwarding not verified'};
    }

    return {level: Level.PENDING, text: 'Replying not verified'};
}
